import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { ButtonIcon } from "@waytek/MobiusOverrides/Button/Button";
import { productCarouselStyles } from "@waytek/Overrides/Widgets/Common/ProductCarousel";
import { colorStrings, mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

const localColors = {
    globalGuardianBlue: getColor("common.global.guardianBlue"),
    globalWhite: getColor("common.global.white"),
    globalGray: getColor("common.global.lightGray"),
};

productCarouselStyles.titleText = {
    ...productCarouselStyles.titleText,

    css: css`
        ${productCarouselStyles.titleText?.css};
        margin-bottom: 23px;
        text-align: left;

        ${mediaQueriesBP.minMD} {
            margin-bottom: 27px;
        }
    `,
};

productCarouselStyles.mainContainer = {
    ...productCarouselStyles.mainContainer,

    css: css`
        position: relative;
    `,
};

productCarouselStyles.prevArrowGridItem = {
    ...productCarouselStyles.prevArrowGridItem,

    css: css`
        position: absolute;
        z-index: 100;
        left: -5px;
        top: 50%;
        transform: translateY(-50%);
        width: auto;
        max-width: unset;

        ${mediaQueriesBP.minMD} {
            left: -20px;
        }

        @media screen and (min-width: 1260px) {
            left: -26px;
        }

        ${mediaQueriesBP.minWide} {
            left: -36px;
        }
    `,
};

productCarouselStyles.nextArrowGridItem = {
    ...productCarouselStyles.nextArrowGridItem,

    css: css`
        position: absolute;
        z-index: 100;
        right: -5px;
        top: 50%;
        transform: translateY(-50%);
        width: auto;
        max-width: unset;

        ${mediaQueriesBP.minMD} {
            right: -20px;
        }

        @media screen and (min-width: 1260px) {
            right: -26px;
        }

        ${mediaQueriesBP.minWide} {
            right: -36px;
        }
    `,
};

productCarouselStyles.prevArrowButton = {
    ...productCarouselStyles.prevArrowButton,

    css: css`
        ${productCarouselStyles.prevArrowButton?.css};
        background: ${localColors.globalWhite};
        outline: none !important;
        min-height: unset;
        border: 1px solid ${localColors.globalGuardianBlue};
        border-radius: 50%;

        &::after {
            content: none;
        }

        svg {
            color: ${localColors.globalGuardianBlue};
        }

        &:not(:disabled):hover {
            background: none;
            background-color: ${localColors.globalGuardianBlue};

            ${ButtonIcon} {
                color: ${localColors.globalGuardianBlue};
            }

            svg {
                color: ${localColors.globalWhite};
            }
        }

        &:disabled {
            svg {
                color: ${localColors.globalGray};
            }
        }

        ${mediaQueriesBP.minLG} {
            width: 30px;
            height: 30px;

            span,
            svg {
                height: 24px;
                width: 24px;
            }
        }
    `,
};

productCarouselStyles.nextArrowButton = {
    ...productCarouselStyles.nextArrowButton,

    css: css`
        ${productCarouselStyles.nextArrowButton?.css};
        background: ${localColors.globalWhite};
        outline: none !important;
        min-height: unset;
        border: 1px solid ${localColors.globalGuardianBlue};
        border-radius: 50%;

        &::after {
            content: none;
        }

        svg {
            color: ${localColors.globalGuardianBlue};
        }

        &:not(:disabled):hover {
            background: none;
            background-color: ${localColors.globalGuardianBlue};

            ${ButtonIcon} {
                color: ${localColors.globalGuardianBlue};
            }

            svg {
                color: ${localColors.globalWhite};
            }
        }

        &:disabled {
            svg {
                color: ${localColors.globalGray};
            }
        }

        ${mediaQueriesBP.minLG} {
            width: 30px;
            height: 30px;

            span,
            svg {
                height: 24px;
                width: 24px;
            }
        }
    `,
};

productCarouselStyles.carouselGridItem = {
    ...productCarouselStyles.carouselGridItem,

    width: 12,
    css: css`
        ${mediaQueriesBP.maxMD} {
            padding-left: 28px;
            padding-right: 28px;
        }
    `,
};

productCarouselStyles.carouselWrapper = {
    ...productCarouselStyles.carouselWrapper,

    css: css`
        width: calc(100% + 20px);
        margin-left: -10px;
        margin-right: -10px;
    `,
};

productCarouselStyles.npCtaContainer = {
    ...productCarouselStyles.npCtaContainer,

    gap: 0,

    css: css`
        margin-top: 30px;

        ${mediaQueriesBP.minMD} {
            margin-top: 40px;
        }
    `,
};

productCarouselStyles.npCtaItem = {
    ...productCarouselStyles.npCtaItem,

    width: 12,

    css: css`
        justify-content: center;
    `,
};

productCarouselStyles.npCtaBtn = {
    ...productCarouselStyles.npCtaBtn,

    css: css`
        ${mediaQueriesBP.minMD} {
            padding: 0 75px;
            min-height: 50px;

            ${TypographyStyle} {
                font-size: 18px;
            }
        }
    `,
};
